/*

IMPORTANT:
Ajax requests that update Shopify's cart must be queued and sent synchronously to the server.
Meaning: you must wait for your 1st ajax callback to send your 2nd request, and then wait
for its callback to send your 3rd request, etc.
*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*
Override so that Shopify.formatMoney returns pretty
money values instead of cents.
*/

Shopify.money_format = '${{amount}}';
Shopify.secure_url;
Shopify.permanent_domain;
Shopify.runPromotions = function(){ };
Shopify.discountCode;
Shopify.promotionConfig = {};
Shopify.getCookie = function(name) {
	return (document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2];
};

Shopify.onError = function(type, message) {
  // Shopify returns a description of the error in XMLHttpRequest.responseText.
  // It is JSON.
  // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = message;
  if (message) {
    console.log(type +': '+ data.message);
  } else {
    console.log('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

Shopify.loader = function(create=true) {
  var loader = document.querySelector('.loader');
  
  var mini_cart_target = document.querySelector('.cart-contents');
  var cart_target = document.querySelector('.section-cart');
  var target = (mini_cart_target)?mini_cart_target:cart_target;
  
  if(create) {
    if(!loader) {
      loader = document.createElement('div');
      loader.classList.add('loader');
      loader.innerHTML = "<div class='loader-circle'></div>";
      if( target ) { target.prepend( loader ); }
      return true;
    } else {
      loader.style.opacity = 1;
      return true;
    }
  }else if(loader) {
    if( loader.style.opacity == 0 ) { 
      loader.remove(); return true; 
    } else {
      loader.style.opacity = 0;
      loader.addEventListener("transitionend", function(){ 
        loader.remove(); 
        return true; 
      });
    }
  }
}

Shopify.fullMessagesFromErrors = function(errors) {
  var fullMessages = [];
  jQuery.each(errors, function(attribute, messages) {
    jQuery.each(messages, function(index, message) {
      fullMessages.push(attribute + ' ' + message);
    });
  });
  return fullMessages
}

Shopify.updateCartElements = function(cart) {
  /*
  var cartPage_TotalItems = document.querySelectorAll('[cart-quantity]');
  var miniCart_TotalItems = document.querySelectorAll('[mini-cart-count]');
  var cart_OriginalTotalPrice = document.querySelector('[cart-original-total-price]');
  var cart_TotalPrice = document.querySelector('[cart-total-price]');
  var miniCart_buttonCheckout = document.querySelector('[mini-cart-btn-checkout]');
  var miniCart_buttonShop = document.querySelector('[mini-cart-btn-shop]');
  var miniCart_buttonCart = document.querySelector('[mini-cart-btn-cart]');
  var cart_noItems = document.getElementById('cartNoItems');
  var cart_hasItems = document.getElementById('cartHasItems');
  var item_count = cart.item_count;

  if(cart_noItems) cart_noItems.style.display = (item_count == 0)?'block':'none';
  if(cart_hasItems) cart_hasItems.style.display = (item_count == 0)?'none':'block';

  if(cartPage_TotalItems) cartPage_TotalItems.forEach((ele) => { ele.innerHTML = item_count; });
  if(miniCart_TotalItems) miniCart_TotalItems.forEach((ele) => { ele.innerHTML = item_count; });

  if(miniCart_buttonShop) miniCart_buttonShop.style.display = (item_count > 0)?'none':'block';
  if(miniCart_buttonCheckout) miniCart_buttonCheckout.style.display = (item_count > 0)?'block':'none';
  
  if(cart_OriginalTotalPrice) { cart_OriginalTotalPrice.innerHTML = Shopify.formatMoney( cart.original_total_price ); }
  if(cart_TotalPrice) { cart_TotalPrice.innerHTML = Shopify.formatMoney( cart.total_price ); }
  if(miniCart_buttonCart) miniCart_buttonCart.style.display = (item_count > 0)?'block':'none';
  Shopify.loader(false);
  */
}

Shopify.updateCartElement = function(item) {
  let item_ele = document.querySelectorAll('.order-list li[data-variant-id="'+item.id+'"]');
}

Shopify.onCartUpdate = function(cart) {
  /*
  if(!cart) {
    Shopify.getCart(function(data){ Shopify.updateCartElements( data ); });
  } else {
    Shopify.updateCartElements(cart);
  }
  Shopify.loader(false);
  Shopify.runPromotions();
  */

};

Shopify.onCartShippingRatesUpdate = function(rates, shipping_address) {
  var readable_address = '';
  if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
  if (shipping_address.province) readable_address += shipping_address.province + ', ';
  readable_address += shipping_address.country
  //alert('There are ' + rates.length + ' shipping rates available for ' + readable_address +', starting at '+ Shopify.formatMoney(rates[0].price) +'.');
};

Shopify.onItemAdded = function(item) {
  /*
  var cart_items = document.querySelectorAll('.order-list');
  var item_element = document.querySelector('li[data-variant-id="'+item.variant_id+'"]');

  if( !item_element ) {
    var itemMarkup = '';
    itemMarkup += '<div class="media-body">';
    if( item["properties"] && item["properties"]["shipping_interval_unit_type"] ) {
      itemMarkup += '<div class="d-flex cart-item" data-is-subscription="true">';
    } else {
      if( item["properties"] && item["properties"]["shipping_interval_unit_type"] ) {
        itemMarkup += '<div class="d-flex cart-item" data-is-subscription="true">';
      } else {
      	itemMarkup += '<div class="d-flex cart-item">';
      }
    }

    itemMarkup += '<div class="item-image">';
    itemMarkup += '<a href="'+ item.url +'"><img src="'+ item.image +'" alt="'+ item.title +'" width="200" height="200" class="img-fluid" /></a>';
    itemMarkup += '</div>';
    itemMarkup += '<div class="item-body flex-fill">';
    itemMarkup += '<a href="'+ item.url +'"><h6 class="title">'+ item.product_title +'</h6></a>';
    itemMarkup += '<div class="text-muted">';
    if(item.options_with_values.length > 0 ) {
      item.options_with_values.forEach(option => {
        itemMarkup += '<p><em>'+ option.value +'</em></p>';
      });
    } // if(item.variant_options.length > 1 ) 
    if( item["properties"] && item["properties"]["shipping_interval_unit_type"] ) {
      	itemMarkup += '<p class="rc_cart__selling-plan item-selling-plan">Every '+  item["properties"]["shipping_interval_frequency"] +' '+ item["properties"]["shipping_interval_unit_type"].toLowerCase() +'</p>';
    } else if( item.selling_plan_allocation ) {
      itemMarkup += '<p class="rc_cart__selling-plan item-selling-plan">'+item.selling_plan_allocation.selling_plan.name;
      if(item.selling_plan_allocation.selling_plan.price_adjustments ) {
		itemMarkup += ', save ';
      }
      item.selling_plan_allocation.selling_plan.price_adjustments.forEach(price_adjustment => {
        if( price_adjustment.value ){
          if(price_adjustment.value_type == 'percentage') {
            itemMarkup += price_adjustment.value+"%";
          } else {
            itemMarkup += Shopify.formatMoney(price_adjustment.value);
          }
           itemMarkup += ' on each order';
        }
      });
      itemMarkup += '</p>';
    } // if(item.selling_plan_allocation.selling_plan.name )
    
    itemMarkup += '</div>';
    itemMarkup += '<div class="d-flex gap-2 justify-content-between">';
    itemMarkup += '<div>';
    if( item.line_price < 1 || item.title.includes("Gift") || item.title.includes("Sample") ) {
      itemMarkup += '<div class="input-quantity"><input class="form-control" id="quantity-'+ item.variant_id +'" data-variant-id="'+ item.variant_id +'" value="1" type="number" readonly /></div>';
    } else {
      itemMarkup += '<div class="input-quantity"><input class="form-control" id="quantity-'+ item.variant_id +'" data-variant-id="'+ item.variant_id +'" data-variant-price="'+item.price+'" type="number" name="updates[]" value="1" min="1" pattern="[0-9]*" quantity-select /></div>';
    }
    itemMarkup += '<a class="text-secondary" remove-from-cart data-product-id="'+item.product_id+'" data-variant-id="'+item.variant_id+'"><small>Remove item</small></a>';
    itemMarkup += '</div>';
    itemMarkup += '<div class="text-end"><p>';
    if( item.original_price > item.line_price ) {
      itemMarkup += '<s><span item-original-price>'+ Shopify.formatMoney(item.original_price) +'</span></s>';
    }
    itemMarkup += '<span item-price>'+ Shopify.formatMoney(item.line_price) +'</span>';
    itemMarkup += '</p></div>';

    itemMarkup += '</div></div></div>';

    var item_ele = document.createElement('li');
    item_ele.setAttribute('data-variant-id', item.variant_id);
    item_ele.classList.add('media');
    item_ele.innerHTML = itemMarkup;
    cart_items.forEach((ele) => { ele.prepend(item_ele ); });
  }

  Shopify.onCartUpdate();
  //alert(line_item.title + ' was added to your shopping cart.');
  */
};

Shopify.onProduct = function(product) {
 //alert('Received everything we ever wanted to know about ' + product.title);
};

/* Tools */

/*
Examples of call:
Shopify.formatMoney(600000, 'â‚¬{{amount_with_comma_separator}} EUR')
Shopify.formatMoney(600000, 'â‚¬{{amount}} EUR')
Shopify.formatMoney(600000, '${{amount_no_decimals}}')
Shopify.formatMoney(600000, '{{ shop.money_format }}') in a Liquid template!

In a Liquid template, you have access to a shop money formats with:
{{ shop.money_format }}
{{ shop.money_with_currency_format }}
{{ shop.money_without_currency_format }}
All these formats are editable on the Preferences page in your admin.
*/
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

Shopify.resizeImage = function(image, size) {
  try {
    if(size == 'original') { return image; }
    else {
      var matches = image.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return matches[1] + '_' + size + '.' + matches[2];
    }
  } catch (e) { return image; }
};

/* Ajax API */

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------
Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  let formData = { 'items': [{ 'id': variant_id, 'quantity': quantity }] };
  let item = false;
  
  Shopify.loader(true);
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    data['items'].forEach((item) => { Shopify.onItemAdded(item); });   
    if ((typeof callback) === 'function') {
      callback(item);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });

};

// ---------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item.
// ---------------------------------------------------------
Shopify.addItemFromForm = function(form_id, callback) {
  let form = document.getElementById(form_id);
  let formData = new FormData(form);
  let item = false;
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    Shopify.onItemAdded(data);
    if ((typeof callback) === 'function') {
      callback(data);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });
};

// ---------------------------------------------------------
// GET cart.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.getCart = function(callback) {
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => { 
    if ((typeof callback) === 'function') {
      callback(data);
    } else {
     return data; 
    }
  });
};

Shopify.pollForCartShippingRatesForDestination = function(shippingAddress, callback, errback) {
  errback = errback || Shopify.onError;
  var poller = function() {
    jQuery.ajax('/cart/async_shipping_rates', {
      dataType: 'json',
      success: function(response, textStatus, xhr) {
        if (xhr.status === 200) {
          if ((typeof callback) == 'function') {
            callback(response.shipping_rates, shippingAddress)
          } else {
            Shopify.onCartShippingRatesUpdate(response.shipping_rates, shippingAddress)
          }
        } else {
          setTimeout(poller, 500)
        }
      },
      error: errback
    })
  }

  return poller;
}

Shopify.getCartShippingRatesForDestination = function(shippingAddress, callback, errback) {
  errback = errback || Shopify.onError;
  var params = {
    type: 'POST',
    url: '/cart/prepare_shipping_rates',
    data: Shopify.param({'shipping_address': shippingAddress}),
    success: Shopify.pollForCartShippingRatesForDestination(shippingAddress, callback, errback),
    error: errback
  }

  jQuery.ajax(params);
}

// ---------------------------------------------------------
// GET products/<product-handle>.js returns the product in JSON.
// ---------------------------------------------------------
Shopify.getProduct = function(handle, callback) {
  fetch('/products/' + handle + '.js')
  .then(response => response.json())
  .then(data => { 
    Shopify.onProduct(data);
    if ((typeof callback) === 'function') {
      callback(data);
    }
  });
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.changeItem = function(variant_id, quantity, callback) {
  
  let item_ele = (quantity==0)?document.querySelectorAll('.order-list li[data-variant-id="'+variant_id+'"]'):false;
  let formData = { id: String(variant_id), quantity: quantity };
  let item = false;
  
  Shopify.loader(true);
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    if(item_ele) item_ele.forEach((ele) => { ele.remove(); });  /* loop through all item lists and remove this items element */
    Shopify.onCartUpdate(data);
    if ((typeof callback) === 'function') {
      callback(data);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.removeItem = function(variant_id, callback) {
  
  let item_ele = document.querySelectorAll('.order-list li[data-variant-id="'+variant_id+'"]');
  let formData = { id: String(variant_id), quantity: 0 };
  let item = false;
  
  Shopify.loader(true);
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    if(item_ele) item_ele.forEach((ele) => { ele.remove(); });  /* loop through all item lists and remove this items element */
    Shopify.onCartUpdate(data);
    if ((typeof callback) === 'function') {
      callback(data);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });
};

Shopify.removeItems = function(formData, callback) {

  Shopify.loader(true);
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    
    console.dir(data);

    Shopify.onCartUpdate(data);
    if ((typeof callback) === 'function') {
      callback(data);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });
};

// ---------------------------------------------------------
// POST to cart/clear.js returns the cart in JSON.
// It removes all the items in the cart, but does
// not clear the cart attributes nor the cart note.
// ---------------------------------------------------------
Shopify.clear = function(callback) {
  
  Shopify.loader(true);
  
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    Shopify.onCartUpdate(data);
    if ((typeof callback) === 'function') {
      callback(data);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });
  
};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.updateCartFromForm = function(form_id, callback) {
  
  let updateCartForm = document.getElementById(form_id);
  let formData = new FormData(updateCartForm);

  fetch('/cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    Shopify.onCartUpdate(data);
    if ((typeof callback) === 'function') {
      callback(data);
    }
  })
  .catch((error) => {
    Shopify.onError('Error:', error);
  });

};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// To clear a particular attribute, set its value to an empty string.
// Receives attributes as a hash or array. Look at comments below.
// ---------------------------------------------------------
Shopify.updateCartAttributes = function(attributes, callback) {
  var data = '';
  // If attributes is an array of the form:
  // [ { key: 'my key', value: 'my value' }, ... ]
  if (jQuery.isArray(attributes)) {
    jQuery.each(attributes, function(indexInArray, valueOfElement) {
      var key = attributeToString(valueOfElement.key);
      if (key !== '') {
        data += 'attributes[' + key + ']=' + attributeToString(valueOfElement.value) + '&';
      }
    });
  }
  // If attributes is a hash of the form:
  // { 'my key' : 'my value', ... }
  else if ((typeof attributes === 'object') && attributes !== null) {
    jQuery.each(attributes, function(key, value) {
        data += 'attributes[' + attributeToString(key) + ']=' + attributeToString(value) + '&';
    });
  }
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


if (jQuery.fn.jquery >= '1.4') {
  Shopify.param = jQuery.param;
} else {
  Shopify.param = function( a ) {
    var s = [],
      add = function( key, value ) {
        // If value is a function, invoke it and return its value
        value = jQuery.isFunction(value) ? value() : value;
        s[ s.length ] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
      };

    // If an array was passed in, assume that it is an array of form elements.
    if ( jQuery.isArray(a) || a.jquery ) {
      // Serialize the form elements
      jQuery.each( a, function() {
        add( this.name, this.value );
      });

    } else {
      for ( var prefix in a ) {
        Shopify.buildParams( prefix, a[prefix], add );
      }
    }

    // Return the resulting serialization
    return s.join("&").replace(/%20/g, "+");
  }

  Shopify.buildParams = function( prefix, obj, add ) {
    if ( jQuery.isArray(obj) && obj.length ) {
      // Serialize array item.
      jQuery.each( obj, function( i, v ) {
        if ( rbracket.test( prefix ) ) {
          // Treat each array item as a scalar.
          add( prefix, v );

        } else {
          Shopify.buildParams( prefix + "[" + ( typeof v === "object" || jQuery.isArray(v) ? i : "" ) + "]", v, add );
        }
      });

    } else if ( obj != null && typeof obj === "object" ) {
      if ( Shopify.isEmptyObject( obj ) ) {
        add( prefix, "" );

      // Serialize object item.
      } else {
        jQuery.each( obj, function( k, v ) {
          Shopify.buildParams( prefix + "[" + k + "]", v, add );
        });
      }

    } else {
      // Serialize scalar item.
      add( prefix, obj );
    }
  }

  Shopify.isEmptyObject = function( obj ) {
    for ( var name in obj ) {
      return false;
    }
    return true;
  }
}


/* Used by Tools */

function floatToString(numeric, decimals) {
  var amount = numeric.toFixed(decimals).toString();
  if(amount.match(/^\.\d+/)) {return "0"+amount; }
  else { return amount; }
}

/* Used by API */

function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    // Converts to a string.
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  // Removing leading and trailing whitespace.
  return jQuery.trim(attribute);
}